import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getMarginBottomClass, marginBottomLevels } from '../../utils/marginBottom/index.js';

var Section = function Section(_ref) {
  var children = _ref.children,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 6 : _ref$marginBottom,
      rest = _objectWithoutProperties(_ref, ["children", "marginBottom"]);

  return React.createElement("section", _extends({
    className: cn('Section', getMarginBottomClass(marginBottom))
  }, rest), children);
};

Section.displayName = 'Section';
Section.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default Section;